export default "__VITE_ASSET__BDCEY069__"